export default __webpack_public_path__ + "static/media/dr-who-annual.ee0ab3d0.jpg";